import * as Yup from "yup";

export const UpdateDiscountCodeSchema = () => {
  return Yup.object().shape({
    referrerValue: Yup.string().required("generic:validation-required"),
    referralValue: Yup.string().required("generic:validation-required"),
    code: Yup.string().required("generic:validation-required")
  });
};
